const IS_TILT = window.location.hostname.includes('local.cast.ai');
const debugReportingTrial =
  new URLSearchParams(window.location.search).get('debug_reporting_trial') ===
  'true';

export const REPORTING_TRIAL_ENABLED = !IS_TILT || debugReportingTrial;
